export * from './initialization-api.service';
import { InitializationApiService } from './initialization-api.service';
export const APIS = [InitializationApiService];
